
<template>
     <v-app-bar
      app
      color="white"
      dense
      elevation="1"
      height="75px"
      dark
    >
      <div class="d-flex align-center ">
        

        <v-img
          alt="Vuetify Name"
          class="shrink  "
          contain
          min-width="100"
          src="../../assets/logos.png"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-spacer></v-spacer>
      <v-btn to="/" text color="primary" class="text-initial body-1 hidden-sm-and-down">
        <span class="mr-2">Inicio</span>
      </v-btn>
      <v-btn to="/about" text color="primary" class="text-initial body-1 hidden-sm-and-down">
        <span class="mr-2">Nosotros</span>
      </v-btn>
      <v-btn to="/services" text color="primary" class="text-initial body-1 hidden-sm-and-down">
        <span class="mr-2">Servicios</span>
      </v-btn>
      <v-btn to="/contact" text color="primary" class="text-initial body-1 hidden-sm-and-down">
        <span class="mr-2">Contacto</span>
      </v-btn>
      <v-app-bar-nav-icon class="hidden-md-and-up" color="primary" @click.stop="openDrawer"></v-app-bar-nav-icon>
    </v-app-bar>
</template>
<script>
export default {
    name: 'HeaderTwo',
}
  </script>
<style scoped>
.text-initial {
  text-transform: initial;
}
</style>